export default {
  columnGap: '58px',
  firstColumnGap: '-12px',
  buttonGap: '25px'
}
